import { getApiErrorMessage } from 'redux-store/helpers/get-api-error-message';
import useToast from './useToast';

export const useCatchServerError = () => {
  const showToast = useToast();

  const catchError = (err: unknown) => {
    showToast({
      type: 'error',
      message: getApiErrorMessage(err),
    });
  };

  return { catchError };
};
